import NextLink from 'next/link';

import { Avatar, AvatarContent, AvatarDescription, AvatarFallback, AvatarTitle } from '@playbooks/ui/components/avatar';
import { FarIcon } from '@playbooks/ui/components/icon';

const GuestAboutCard = () => (
	<NextLink
		href='/auth'
		className='group block w-full rounded-panel p-2 text-left text-foreground outline-none hover:bg-surface-hover focus-visible:ring-3 focus-visible:ring-focus/50'>
		<Avatar className='flex-start w-full gap-3'>
			<AvatarFallback className='size-9 rounded-panel'>
				<FarIcon icon='hand-wave' />
			</AvatarFallback>
			<AvatarContent className='flex-column min-w-0 gap-0.5 text-left'>
				<AvatarTitle className='w-full text-left text-base leading-none'>Get Started</AvatarTitle>
				<AvatarDescription className='w-full truncate text-left leading-tight'>Continue to Playbooks</AvatarDescription>
			</AvatarContent>
		</Avatar>
	</NextLink>
);
export { GuestAboutCard };
